import { Badge, Button, Card, CardBody, Col } from "reactstrap"
import Loader from "./Loader"

export const AlertsCard = ({ alertsData, loading, handleImageClick }) => {
  return (
    <>
      {loading ? (
        // Show skeleton loaders while loading
        Array.from({ length: 4 }).map((_, index) => (
          <Col lg={3} md={6} key={index} className="mb-4">
            <Card className="camera-card h-100">
              <div className="camera-image-container position-relative d-flex justify-content-center align-items-center" style={{ height: '200px', backgroundColor: '#f8f9fa' }}>
                <Loader size="lg" />
              </div>
              <CardBody className="text-center d-flex flex-column gap-2">
                <div className="d-flex justify-content-between">
                  <p className="mb-0">Camera ID:</p>
                  <Loader size="xs" />
                </div>

                <div className="d-flex justify-content-between">
                  <span>Zone</span>
                  <Loader size="xs" />
                </div>
                <div className="d-flex justify-content-between">
                  <p>Detected Time</p>
                  <Loader size="xs" />
                </div>
              </CardBody>
            </Card>
          </Col>
        ))
      ) : (
        alertsData.map((camera) => (
          <Col lg={3} md={6} key={camera.id} className="mb-4">
            <Card className="camera-card h-100">
              <div className="camera-image-container position-relative">
                <img
                  src={camera.annotated_url}
                  alt={'Image issue'}
                  className="camera-image"
                  onError={(e) => {
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPkNhbWVyYSBGZWVkPC90ZXh0Pjwvc3ZnPg=='
                  }}
                />
                <Badge
                  color={camera.statusColor}
                  className="status-badge position-absolute"
                >
                  {camera.module_name}
                </Badge>
              </div>
              <CardBody className="text-center d-flex flex-column gap-2">
                <div className="d-flex justify-content-between">
                  <p className="mb-0">Camera</p>
                  <p className="mb-0">{camera.camera_name}</p>
                </div>

                <div className="d-flex justify-content-between">
                  <p className="mb-0">Zone</p>
                  <p className="mb-0">{camera.zone_name}</p>
                </div>
                <div className="d-flex justify-content-between">
                  <p className="mb-0">Detected Date</p>
                  <p className="mb-0">{camera?.timestamp?.split('T')[0]}</p>
                </div>

                <div className="d-flex justify-content-between">
                  <p className="mb-0">Detected Time</p>
                  <p className="mb-0">{camera?.timestamp?.split("T")[1]?.split("+")[0]}</p>
                  {/* <p className="mb-0">{camera?.timestamp?.split('T')[1]?.split('.')[0]}</p> */}
                </div>



                <div className="d-flex gap-2 mt-2">
                  <Button
                    color="primary"
                    outline
                    className="w-100 d-flex align-items-center justify-content-center"
                    style={{borderRadius:'6px' , fontSize: '10px'}}
                    onClick={() => handleImageClick(camera.annotated_url, {
  cameraId: camera.camera_id,
  zone: camera.zone_name,
  detectedDate: camera?.timestamp?.split('T')[0],
  detectedTime: camera?.timestamp?.split('T')[1]?.split('.')[0]
})}
                  >
                    {/* <i className="fa fa-eye me-2"></i> */}
                    View Details
                  </Button>
                  <Button
                    color="primary"
                    className="w-100 d-flex align-items-center justify-content-center"
                    style={{ backgroundColor: '#5dade2', borderColor: '#5dade2' }}
                  >
                    {/* <i className="fa fa-eye me-2"></i> */}
                    Aknowledge
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        ))
      )}
    </>

  )
}